import styled from 'styled-components';

const PreviewStyle = styled.div`
    .preview {
        &-item {
            width: 100%;
            max-width: 326px;
            &-text {
                margin: 12px 16px 0 20px;
                //padding: 0 20px 0 16px;

                &-subTitle {
                    margin-top: 8px;
                    display: -webkit-box;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;

                    white-space: normal;
                    line-height: 1.5;
                    max-height: calc(1.5em * 4);
                }

                &-info {
                    margin-top: 12px;
                }
            }
            &-image {
                overflow: hidden;
            }
            img {
                transition: 0.35s;
            }
            &:hover {
                img {
                    transform: scale(1.2);
                    transition: 0.35s;
                }
            }
        }
    }

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
	}
	/* //! 1510 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
	}
	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {

        .preview-item {
            max-width: 100%;
        }
    }
	/* //! 414 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {

        .preview-item-text {
            margin: 2px 7px 0;
        }

        .preview-item-text-subTitle {
            margin-top: 0;
        }

        .preview-item-text-info {
            margin-top: 2px;
        }
	}
`;

export default PreviewStyle;
